import React, {useEffect} from "react";
import banals from "../img/balans.png";
import bank from "../img/bank.png";
import tax from "../img/tax.png";
import emek from "../img/emek.png";
import qaime from "../img/qaime.png";
import kassa from "../img/kassa.png";
import ambar from "../img/ambar.png";
import { useTranslation } from "react-i18next";

const ProgramAdvantages = () => {
 const { t, i18n } = useTranslation();
 
   const changeLanguage = (lng) => {
     i18n.changeLanguage(lng);
     localStorage.setItem("lng", lng);
   };
 
   useEffect(() => {
     changeLanguage(localStorage.getItem("lng") || "en");
   }, []);

  const advantages = [
    { header: t("advantages_balance"), text1: t("advantages_balance_text1"), text2: t("advantages_balance_text2"), text3: t("advantages_balance_text3"), text4: t("advantages_balance_text4"), img: banals, alt: "Balans" },
    { header: t("advantages_invoice"), text1: t("advantages_invoice_text1"), text2: t("advantages_invoice_text2"), img: qaime, alt: "Qaime" },
    { header: t("advantages_labor"), text1: t("advantages_labor_text1"), text2: t("advantages_labor_text2"), img: emek, alt: "Emek" },
    { header: t("advantages_ambar"), text1: t("advantages_ambar_text1"), text2: t("advantages_ambar_text2"), text3:t("advantages_ambar_text3"), img: ambar, alt: "Ambar" },
    { header: t("advantages_kassa"), text1: t("advantages_kassa_text1"), text2: t("advantages_kassa_text2"), img: kassa, alt: "Kassa" },
    { header: t("advantages_bank"), text1: t("advantages_bank_text1"), text2: t("advantages_bank_text2"), img: bank, alt: "Bank" },
    { header: t("advantages_tax"), text1: t("advantages_tax_text1"), text2: t("advantages_tax_text2"),  img: tax, alt: "ƏDV" },
  ];

  return (
    <div className=" px-4 py-16 sm:px-6 md:px-10  bg-white">
      <div className="mx-auto w-full max-w-screen-xl ">
        <div className="header text-center sm:mb-14 mb-5 text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-500">
          {t("advantages_header")}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 justify-center">
          {advantages.slice(0, 4).map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-primary/60 to-primaryDark/70 backdrop-blur-lg text-white h-72 p-6 rounded-xl shadow-md flex flex-col items-center justify-center text-center transition-transform transform hover:-translate-y-2 "
            >
              <img src={item.img} alt={item.alt} className=" text-white w-16 h-16 mb-4" />
              <h3 className="text-lg font-semibold mb-2">{item.header}</h3>
              <div className="absolute inset-0 bg-[#3065a1] text-white flex items-center justify-center text-center px-4 opacity-0 hover:opacity-100 transition-opacity rounded-xl">
              <ul className="list-disc space-y-2 pl-4">
  {Object.keys(item)
    .filter((key) => key.startsWith("text") && item[key]) // Фильтруем только ключи, начинающиеся с "text" и имеющие значение
    .map((key, index) => (
      <li className="text-start" key={index}>{item[key]}</li> // Создаем <li> для каждого найденного ключа
    ))}
</ul>

              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 justify-center mt-6">
          {advantages.slice(4).map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-primary/60 to-primaryDark/70 backdrop-blur-lg h-72 p-6 text-white rounded-xl shadow-md flex flex-col items-center justify-center text-center transition-transform transform hover:-translate-y-2 "
            >
              <img src={item.img} alt={item.alt} className="w-16 h-16 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">{item.header}</h3>
              <div className="absolute inset-0 bg-[#3065a1] text-white flex items-center justify-center text-center px-4 opacity-0 hover:opacity-100 transition-opacity rounded-xl">
              <ul className="list-disc space-y-2 pl-4">
  {Object.keys(item)
    .filter((key) => key.startsWith("text") && item[key]) // Фильтруем только ключи, начинающиеся с "text" и имеющие значение
    .map((key, index) => (
      <li className="text-start" key={index}>{item[key]}</li> // Создаем <li> для каждого найденного ключа
    ))}
</ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgramAdvantages;